export const adminNoticeSelector = (state) => state.adminReducer.board.notice;
export const adminPostsSelector = (state) => state.adminReducer.board.posts;
export const adminNewsBannerSelector = (state) => state.adminReducer.newsBanner;
export const adminFittingSelector = (state) => state.adminReducer.fitting;
export const adminLogoSelector = (state) => state.adminReducer.logo;
export const adminBackgroundSelector = (state) => state.adminReducer.background;